
export const CC_EMAILS = [
  "rayapu00@rediffmail.com",
  "rayikaur@rediffmail.com"
];
export const BACKEND_APP_URL = "https://brandsonmove.com/api"
export const SOCKET_IO_BACKEND_APP_URL = "https://brandsonmove.com"
